import React, { useState, useEffect } from "react";
import Spreadsheet from "react-spreadsheet";
import VesselHeader from "../../components/Vessel/VesselHeader";
import { useDispatch, useSelector } from "react-redux";
import {getEUMRVData} from '../../services/complianceService';
import BenchmarkYearPicker from "../../components/Common/BenchmarkYearPicker";
import ExportToExcel from "../../components/Common/ExportToExcel";

const EUMRV = () => {
  const dispatch = useDispatch();
  const { currentVessel } = useSelector((state) => state.vesselOverview);
  const staticData = [
    // Header row
    [
      {
        value: "EUMRVStatus",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "VoyageTimeAtSea",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "FuelConsHFO",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "HFOCo2EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "HFO N20 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "HFO CH4 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "FuelConsLFO",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "LFOCo2EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "LFON20EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "LFO CH4 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "FuelConsMDO",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "MDO Co2 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "MDO N20 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "MDO CH4 EmissionFactor",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "N2OEmission",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "CH4Emission",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "DistanceSailed",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "TransportWork",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "CO2EmissionPerNm",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "CO2Eq. EmissionPerNm",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },

      {
        value: "CO2EmissionPerTransportWork",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "CO2Eq. EmissionPerTransportWork",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "FuelConsPerNm",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "FuelConsPerTransportWork",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "CO2Emitted",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "GHG Emitted",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
      {
        value: "GHGEmitted under ETS",
        readOnly: true,
        className: "font-bold bg-blue-50 text-blue-800",
      },
    ],
    // Data rows
    [
      {
        value: "At EU Port",
        readOnly: true,
        className: "font-medium",
      },
      { value: "0", readOnly: true },
      {
        value: "0",
        readOnly: true,
      },
      {
        value: 3.114,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00018,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "font-medium",
      },
      { value: 3.151, readOnly: true },
      {
        value: 0.00018,
        readOnly: true,
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 71.7,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 3.206,
        readOnly: true,
        className: "font-medium",
      },
      { value: 0.00018, readOnly: true },
      {
        value: 0.00005,
        readOnly: true,
      },
      {
        value: 0.012906,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00362085,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "", readOnly: true },
      {
        value: "",
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 1250.75,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "1", readOnly: true },
      {
        value: 229.87,
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 229.87,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
    ],
    [
      {
        value: "Between EU Ports",
        readOnly: true,
        className: "font-medium",
      },
      { value: "0", readOnly: true },
      {
        value: "0",
        readOnly: true,
      },
      {
        value: 3.114,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00018,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "font-medium",
      },
      { value: 3.151, readOnly: true },
      {
        value: 0.00018,
        readOnly: true,
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 71.7,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 3.206,
        readOnly: true,
        className: "font-medium",
      },
      { value: 0.00018, readOnly: true },
      {
        value: 0.00005,
        readOnly: true,
      },
      {
        value: 0.012906,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00362085,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "", readOnly: true },
      {
        value: "",
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 1250.75,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "1", readOnly: true },
      {
        value: 229.87,
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 229.87,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
    ],
    [
      {
        value: "From EU Port",
        readOnly: true,
        className: "font-medium",
      },
      { value: "0", readOnly: true },
      {
        value: "0",
        readOnly: true,
      },
      {
        value: 3.114,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00018,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "font-medium",
      },
      { value: 3.151, readOnly: true },
      {
        value: 0.00018,
        readOnly: true,
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 71.7,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 3.206,
        readOnly: true,
        className: "font-medium",
      },
      { value: 0.00018, readOnly: true },
      {
        value: 0.00005,
        readOnly: true,
      },
      {
        value: 0.012906,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00362085,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "", readOnly: true },
      {
        value: "",
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 1250.75,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "1", readOnly: true },
      {
        value: 229.87,
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 229.87,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
    ],
    [
      {
        value: "To EU Port",
        readOnly: true,
        className: "font-medium",
      },
      { value: "0", readOnly: true },
      {
        value: "0",
        readOnly: true,
      },
      {
        value: 3.114,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00018,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "font-medium",
      },
      { value: 3.151, readOnly: true },
      {
        value: 0.00018,
        readOnly: true,
      },
      {
        value: 0.00005,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 71.7,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 3.206,
        readOnly: true,
        className: "font-medium",
      },
      { value: 0.00018, readOnly: true },
      {
        value: 0.00005,
        readOnly: true,
      },
      {
        value: 0.012906,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 0.00362085,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "", readOnly: true },
      {
        value: "",
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 1250.75,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: "",
        readOnly: true,
        className: "font-medium",
      },
      { value: "1", readOnly: true },
      {
        value: 229.87,
        readOnly: true,
      },
      {
        value: "",
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 229.87,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "text-blue-600",
      },
      {
        value: 233.39,
        readOnly: true,
        className: "font-mono bg-blue-50/30",
      },
    ],
  ];
  const [data, setData] = useState(staticData);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState(null);

  const benchmarkYear = useSelector((state) => state.benchmarkYear.year);

useEffect(() => {
  const fetchData = async () => {
    if (!currentVessel?._id) {
      setData(Array.isArray(staticData) ? staticData : [staticData]);
      setResponseData(null);
      return;
    }

    setLoading(true);

    try {
      const response = await getEUMRVData(currentVessel._id, benchmarkYear);

      setResponseData(response);

      if (response?.data && response.data.length > 0) {
        setData([...response.data]);
      } else {
        setData(Array.isArray(staticData) ? staticData : [staticData]);
      }
    } catch (err) {
      console.error("Failed to fetch EU MRV data:", err);
      setData(Array.isArray(staticData) ? staticData : [staticData]);
       setResponseData(null);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [currentVessel, benchmarkYear]);

const spreadsheetData = Array.isArray(data) ? data : [data];

const showExportButton = responseData?.summary?.segmentCount > 0;

return (
  <div className="font-sans text-sm min-h-screen bg-gray-50">
    <div className="flex items-center justify-between p-4 border-b border-gray-300">
      <VesselHeader pageTitle="EU MRV Compliance Data" />
      <div className="flex space-x-2">
        <BenchmarkYearPicker />
        {showExportButton && <ExportToExcel />}
      </div>
    </div>

    <div className="p-4">
      <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-x-auto flex items-center justify-center">
        {loading ? (
          <div className="text-gray-500 text-base animate-pulse">
            Loading data...
          </div>
        ) : (
          <div className="min-w-[1100px]">
            <Spreadsheet
              data={spreadsheetData} // Use the validated array
              onChange={setData}
              hideRowIndicators={true}
              hideColumnIndicators={true}
              className="enhanced-spreadsheet"
            />
          </div>
        )}
      </div>
    </div>

    <style jsx global>{`
      .enhanced-spreadsheet {
        --selected-cell: #e3f2fd;
        --selected-row: #f5f5f5;
        --selected-column: #f5f5f5;
      }
      .enhanced-spreadsheet table {
        border-collapse: separate;
        border-spacing: 0;
        width: auto !important;
      }
      .enhanced-spreadsheet td {
        border-right: 1px solid #e5e7eb !important;
        border-bottom: 1px solid #e5e7eb !important;
        padding: 10px 14px !important;
        transition: background-color 0.2s;
        color: #1f2937 !important;
      }
      .enhanced-spreadsheet td:first-child {
        border-left: 1px solid #e5e7eb !important;
      }
      .enhanced-spreadsheet th {
        background-color: #f8fafc !important;
        font-weight: 600 !important;
        color: #1e40af !important;
        border-bottom: 2px solid #e5e7eb !important;
        padding: 12px 14px !important;
      }
      .enhanced-spreadsheet tr:hover td {
        background-color: #f9fafb !important;
      }
      .enhanced-spreadsheet .active-cell {
        box-shadow: inset 0 0 0 2px #3b82f6 !important;
      }
    `}</style>
  </div>
);
}

export default EUMRV;
